module.exports = __webpack_public_path__ + "img/334101314.9c576aea.png";